import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import PlusIcon from 'icons/Plus.icon';
import useCallbackRef from 'hooks/useCallbackRef';
import { SideDrawerRef } from 'router/subrouters/DataRoom/components/SideDrawer/SideDrawer.component';
import AddSellSideColleague from '../components/AddSellSideColleague';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';

const useSellSideActions = () => {
  const { t } = useTranslation();

  const [drawer, drawerRef] = useCallbackRef<SideDrawerRef>(null);
  const { doesntHaveAccess } = useContext(DataRoomContext);

  const RenderAddMemberDrawer = useMemo(
    () => <AddSellSideColleague ref={drawerRef} />,
    [drawerRef],
  );

  const actionButton = useMemo(
    () =>
      doesntHaveAccess ? null : (
        <Button
          icon={PlusIcon}
          onClick={(e) => {
            e.stopPropagation();
            drawer?.setOpen(true);
          }}
        >
          {t('add')}
        </Button>
      ),
    [doesntHaveAccess, drawer, t],
  );

  return { RenderAddMemberDrawer, actionButton };
};

export default useSellSideActions;
